import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Calendar, User, ArrowLeft, Share2, Clock } from "lucide-react";

import BlogRelatedCard from "./relatedCard";
import { formatDate } from "../helper/Helper";
import blogAPI from "../api/BlogApi";

function DetailPage() {
  const { slug } = useParams();

  const [item, setItem] = useState({});
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const [metaData, setMetaData] = useState({});
  const [isScrolled, setIsScrolled] = useState(false);

  const fetchBlogsDetail = async () => {
    try {
      const params = {
        limit: 3,
      };

      const res = await blogAPI.details(slug, params);

      if (res.code === 200) {
        const { blog, relatedBlogs } = res.data;

        setItem(blog);
        setRelatedBlogs(relatedBlogs);
        setMetaData(blog?.meta);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    }
  };

  useEffect(() => {
    fetchBlogsDetail();
  }, [slug]);

  // Premium Animation Variants
  const premiumHeroVariants = {
    initial: { opacity: 0, y: 40 },
    animate: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.8, ease: [0.19, 1, 0.22, 1] }
    },
  };

  const staggerContainer = {
    animate: {
      transition: {
        staggerChildren: 0.15,
      },
    },
  };



useEffect(() => {

  const scrollElement = document.querySelector(
    ".premium-blog-main-content-area"
  );

  const handleScroll = () => {

    if (scrollElement.scrollTop > 80) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }

  };

  scrollElement?.addEventListener("scroll", handleScroll);

  return () => {
    scrollElement?.removeEventListener("scroll", handleScroll);
  };

}, []);


  return (
    <>


     <div className="btn-wrapper fixed-btn">
                    <Link to="/book-your-demo"><button className="ax-custom-banner-sec-btn">
                      Book Your   Free Demo Now
                    </button> </Link>
                  </div>

      <div
   
        className={`premium-blog-layout-root ${isScrolled ? "scrolled" : ""}`}
       >
        <motion.main
          initial="initial"
          animate="animate"
          variants={staggerContainer}
          className="premium-blog-container"
        >
          {/* Back Navigation Bar */}
         

          <div className="premium-blog-grid-system">
            
            {/* LEFT SIDE: MAIN ARTICLE */}
            <section 
            className="premium-blog-main-content-area"
            
            >
              
              <motion.div variants={premiumHeroVariants}>
                <span className="premium-category-badge-pill">
                  Latest Insights
                </span>
              </motion.div>

              <motion.h1
                variants={premiumHeroVariants}
                className="premium-article-main-title"
              >
                {item?.title}
              </motion.h1>

              {/* Enhanced Meta Info Row */}
              <motion.div
                variants={premiumHeroVariants}
                className="premium-article-metadata-row"
              >
                <div className="premium-meta-profile-item">
                  {/* <div className="premium-meta-avatar-fallback">
                    <User size={14} />
                  </div> */}
                  <div className="premium-meta-text-group">
                    <small>Written by</small>
                    <strong>{item?.author || "Editorial Team"}</strong>
                  </div>
                </div>

                <div className="premium-meta-date-item">
                  <Calendar size={15} />
                  <span>{formatDate(item?.date)}</span>
                </div>

                {/* <div className="premium-meta-date-item">
                  <Clock size={15} />
                  <span>5 Min Read</span>
                </div> */}
              </motion.div>

              {/* Hero Image Showcase */}
              <motion.div
                variants={premiumHeroVariants}
                className="premium-article-hero-image-frame"
              >
                <img src={item?.image} alt={item?.title} className="premium-hero-img"   loading="lazy"/>
                <div className="premium-image-overlay-glow"></div>
              </motion.div>

              {/* Rich Text Dynamic Content Rendering */}
              <motion.div
                variants={premiumHeroVariants}
                className="premium-article-rich-text-body"
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: item?.description,
                  }}
                />
              </motion.div>
            </section>

            {/* RIGHT SIDE: SIDEBAR FOR RELATED CONTENT */}
            <aside className="premium-blog-sidebar-sticky-area">
              <div className="premium-sidebar-card-container">
                <div className="premium-sidebar-header-line">
                  <h3 className="premium-sidebar-widget-title">
                    Related Blogs
                  </h3>
                  {/* <div className="premium-accent-dot"></div> */}
                </div>
                
                <div className="premium-sidebar-related-cards-stack">
                  {relatedBlogs &&
                    relatedBlogs.length > 0 &&
                    relatedBlogs.map((blog, index) => (
                      <motion.div
                        key={blog?._id || index}
                        className="premium-related-card-interactive-wrapper"
                        whileHover={{ x: 6 }}
                        transition={{ duration: 0.3 }}
                      >
                        <BlogRelatedCard item={blog} />
                      </motion.div>
                    ))}
                </div>
              </div>
            </aside>

          </div>
        </motion.main>
      </div>
    </>
  );
}

export default DetailPage;